module.exports = __webpack_public_path__ + "media/images/download-9f312bcc.svg";